import { useState, useEffect, useCallback } from 'react';
import { generateClient, GraphQLResult } from 'aws-amplify/api';
import { Site } from '../types';
import { GET_SITE } from '../graphql/queries';

const client = generateClient();

interface GetSiteResponse {
  getSite: Site;
}

export function useSite(siteId: string) {
  const [site, setSite] = useState<Site | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSite = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await client.graphql({
        query: GET_SITE,
        variables: { siteId },
      }) as GraphQLResult<GetSiteResponse>;

      setSite(response.data?.getSite || null);
    } catch (err) {
      console.error('Error fetching site:', err);
      setError('Failed to load site details.');

      // Mock data for development
      if (import.meta.env.DEV) {
        setSite({
          siteId,
          userId: 'user-1',
          name: 'Example Website',
          url: 'https://example.com',
          description: 'Main corporate website',
          status: 'active',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          lastScanScore: 78,
          lastScanGrade: 'C',
        });
      }
    } finally {
      setIsLoading(false);
    }
  }, [siteId]);

  useEffect(() => {
    fetchSite();
  }, [fetchSite]);

  return {
    site,
    isLoading,
    error,
    refetch: fetchSite,
  };
}
